import { LOCAL_STORAGE_KEYS } from 'utils/constants'

export interface Credentials {
  accessToken: string;
  refreshToken: string;
  iduser: string;
}

const lsGetItem = (str: string) => window.localStorage.getItem(str) || localStorage.getItem(str)

export const getCredentials = (): Credentials => ({
  accessToken : lsGetItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)!,
  iduser      : lsGetItem(LOCAL_STORAGE_KEYS.USER_ID)!,
  refreshToken: lsGetItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN)!
})

export const clearStorages = () => {
  const localStorageBckp = []

  for (const key in localStorage)
    try {
      if(key === LOCAL_STORAGE_KEYS.NUMBER_LOGINS) {
        localStorageBckp.push({
          data: localStorage.getItem(key),
          key
        })

        continue
      }

      const parsedKey = JSON.parse(key)
      if(parsedKey.query === 'updateCvKey') {
        localStorageBckp.push({
          data: localStorage.getItem(key),
          key
        })

        continue
      }
    } catch (e) {
    }

  localStorage.clear()

  localStorageBckp.forEach((item) => {
    if(item.data) localStorage.setItem(item.key, item.data)
  })

  sessionStorage.clear()
}
